module.exports = __webpack_public_path__ + "static/media/TT-Magic-Link.21af243c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TT-Magic-Link.png
// module id = 243
// module chunks = 17